import * as React from 'react';
import withStyles, { WithStyles, StyleRules, ClassNameMap } from '@material-ui/core/styles/withStyles';
import { Switch, Route } from 'react-router-dom';
import { Theme } from '@material-ui/core/styles';
import AppView from '~common/components/app-view/index';
import FormBasedEditor from '~common/form/form-based-editor';


const styles = (theme: Theme): StyleRules => ({
	container: {
		width: '100%'
	}
});

interface Props extends React.HTMLProps<HTMLDivElement> {
	history: any;
  match: any;
}

type State = {};

class InviteBulk extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
	constructor(props: Props & WithStyles<keyof typeof styles>) {
		super(props, {});
		this.state = {};
	}

	componentWillReceiveProps(newProps: Props & WithStyles<keyof typeof styles>) {}

	render() {
		const { classes }: { classes: ClassNameMap } = this.props;

		return (
			<div className={classes.container}>
				<AppView history={this.props.history}>
          <FormBasedEditor 
            history={this.props.history} 
			match={this.props.match}
			clearDataOnSubmit={true}
			postOnly={true}
            dataUrl="/api/portal-users/invite/bulk"
            formSelector={{"formType": "inviteBulkPortalUsers", "modules": "users", "userType": "Internal"}}
            successMessage="The invitations will be sent.  You will receive a confirmation email when this is complete"
            submitButtonText="Send Invitations"
          >
          </FormBasedEditor>
        </AppView>
			</div>
		);
	}
}

export default withStyles(styles)(InviteBulk);
